export function RadioCards<T extends string>({
  options,
  value,
  onChange,
  gridClassName = "grid-cols-2 sm:grid-cols-4",
}: {
  options: readonly { value: T; label: string }[];
  value: T | "";
  onChange: (v: T) => void;
  gridClassName?: string;
}) {
  return (
    <div className={`grid gap-2.5 ${gridClassName}`}>
      {options.map((opt) => {
        const isActive = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            aria-pressed={isActive}
            className={`cursor-pointer rounded border-2 px-3 py-3 text-center text-sm font-medium transition ${
              isActive
                ? "border-theme-accent bg-[#F9FBF4] text-ink"
                : "border-border bg-white text-ink-muted hover:border-ink"
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
